import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DomPurify from 'dompurify';
import { ButtonClassNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { extraServicesPriceListDocLink } from '../../../../constants/configuration';

interface IUnionCtvSuspension {
  title: string | undefined;
  service: string | undefined;
  handleProceed: () => void;
  handleClose: () => void;
}

export const UnionCtvSuspension: FC<IUnionCtvSuspension> = ({ title, service, handleProceed, handleClose }) => {
  const { t } = useTranslation();
  const sanitizer = DomPurify.sanitize;

  const handleContinue = () => {
    handleProceed();
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{title}</article>
        <p
          className="modals__header__description"
          dangerouslySetInnerHTML={{
            __html: sanitizer(t('modals.unionCtvSuspensionNotice', { service, price: extraServicesPriceListDocLink }), {
              ADD_ATTR: ['target'],
            }),
          }}
        />
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.continue')}
          handleClick={handleContinue}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.decline')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
      </div>
    </div>
  );
};
